import React, { useState } from 'react';

import Checkbox from 'components/Checkbox';
import Rating from 'components/Rating';

import {
  ContainerItem,
  ImageProfile,
  TextInf,
  RatingRow,
  Business,
  FlexProp,
  DisplayRow,
} from './styles';

const QuotesCard = ({ task, error, handleListSelected }) => {
  const [checked, setChecked] = useState(false);
  const handleCheck = () => { setChecked(!checked); };

  return (
    <ContainerItem
      onClick={(index) => { handleCheck(); handleListSelected(index); }}
      checked={checked}
      error={error}
    >
      <DisplayRow proportion={2.5}>
        <Checkbox type="checkbox" checked={checked} />
        <div style={{ marginLeft: '10px' }}>
          <DisplayRow>
            <ImageProfile src={task.profile_picture} />
            <TextInf>{task.user_name}</TextInf>
          </DisplayRow>
          <Business>{`${task.pro_deals} negócios fechados`}</Business>
        </div>
      </DisplayRow>
      <FlexProp proportion={1}>
        <RatingRow>
          <Rating initialRating={task.rating} readonly />
        </RatingRow>
      </FlexProp>
      <FlexProp proportion={1}><TextInf hAlign="right">{`R$ ${task.price}`}</TextInf></FlexProp>
    </ContainerItem>
  );
};

export default QuotesCard;
